export default function addContext(Component, contextTypes) {
    Component.contextTypes = Component.contextTypes || {};
    Object.assign(Component.contextTypes, contextTypes);

    return Component;
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/component-helpers/addContext.js
// module id = 538
// module chunks = 13